export default {
  methods: {
    convertToYearsHeading: columns => (columns || []).map(c => c.year),
    convertToMonthsHeading: columns => (columns || []).map(c => c.month + '/' + c.year),
    convertToRow: (columns, name) => (columns || []).map(c => c[name]),
    convertToRowGroup (columns, names) {
      const rowGroup = {};

      names.forEach(n => {
        rowGroup[n] = this.convertToRow(columns, n);
      });

      return rowGroup;
    },
    convertToRowGroupAutomatically (columns) {
      const names = [];

      const columnOne = (columns || [])[0] || {};
      for (const n in columnOne) {
        if (n === 'month' || n === 'year') {
          continue;
        }

        names.push(n);
      }

      return this.convertToRowGroup(columns, names);
    },
  },
};
